import { Component, OnInit } from '@angular/core';

import { ErrorTranslationService } from '@bayclubs/utils';
import { BayclubsAlertService } from '@bayclubs/alert';

import { CouponApiService } from '../../../services/api/coupon-api.service';
import { camps } from '../../../models/models.generated';
import { campsenum } from '../../../models/enums.generated';
import { CampsEnumTranslationService } from '../../../services/camps-enum-translation.service';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
    selector: 'app-coupon-details',
    host: { 'data-testid': 'coupon-details-page' },
    templateUrl: './coupon-details.component.html',
    styleUrls: ['./coupon-details.component.scss'],
    standalone: false
})
export class CouponDetailsComponent implements OnInit {
    public item: camps.CouponInfo;

    public history: camps.CouponHistoryItemInfo[] = [];

    public isHistoryLoading: boolean = true;

    constructor(
        private router: Router,
        private activatedRoute: ActivatedRoute,
        private api: CouponApiService,
        private alert: BayclubsAlertService,
        public enumTranslations: CampsEnumTranslationService,
        private errorTranslate: ErrorTranslationService
    ) {}

    ngOnInit() {
        this.activatedRoute.params.subscribe(params => {
            if (params.id) {
                this.loadDetails(params.id);
                this.loadHistory(params.id);
            }
        });
    }

    public loadDetails(id) {
        this.api
            .details(<camps.CouponDetailsRequest>{
                id: id
            })
            .subscribe(x => {
                if (x.isSuccess) {
                    this.item = x.value;
                } else {
                    this.errorTranslate.translateValidationNotifications(x.validationNotification);
                    this.alert.showError(x.validationNotification.errors[0].message);
                }
            });
    }

    public loadHistory(id) {
        this.isHistoryLoading = true;

        this.api
            .history(<camps.CouponHistoryRequest>{
                id: id
            })
            .subscribe(x => {
                if (x.isSuccess) {
                    this.history = x.pageItems;
                } else {
                    this.errorTranslate.translateValidationNotifications(x.validationNotification);
                    this.alert.showError(x.validationNotification.errors[0].message);
                }
                this.isHistoryLoading = false;
            });
    }

    public translateType(): string {
        return this.enumTranslations.couponType(this.item.type);
    }

    public translateUsageType(): string {
        return this.enumTranslations.couponUsageType(this.item.usageType);
    }

    public get isAmount(): boolean {
        return this.item.type == campsenum.CouponType.Amount;
    }

    public get isPercent(): boolean {
        return this.item.type == campsenum.CouponType.Percentage;
    }

    public get isFreeWeeks(): boolean {
        return this.item.type == campsenum.CouponType.FreeWeeks;
    }

    public get isFreeDays(): boolean {
        return this.item.type == campsenum.CouponType.FreeDays;
    }

    public get isUsed(): boolean {
        return this.item.status == campsenum.CouponStatus.Used && this.item.purchase != null;
    }

    public isHistoryTypeUsed(item: camps.CouponHistoryItemInfo) {
        return item.eventType == campsenum.CouponActionType.UsedInCart;
    }

    public goToPurchaseDetails() {
        if (!this.item.purchase) {
            return;
        }

        this.router.navigate(['purchases/' + this.item.purchase.purchaseId + '/details']);
    }
}
